$(window).on("load",(function(){ 
    var inputtext = $(".v_box input[type='radio']:checked").attr('value');
    //$('.first-show').html(inputtext);
    }));
    
     $('.v_box label').on('click', function () {
         var labeltext = $(this).attr('data-val');
         $('.first-show').html(labeltext);
    });
    
     $('.first-show').on('click', function () {     
         $('.variant_row').slideToggle('fast');
       $('.select-hover').toggleClass('active');
    });
     $('.select-hover, .v_box label').on('click', function () {     
         $('.variant_row').slideUp('fast');
        $('.select-hover').removeClass('active');
    });